import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractDynamic from "../Dynamic";

class Dynamic extends AbstractDynamic {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-dynamic-documents-ipr';
  }
}

export default Dynamic;
